import cc from 'classcat';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import css from './index.module.scss';
import Button from '../Button';
import Check from '../icons/Check';
import copyToClipboard from '../../utils/copyToClipboard';

class ClickToCopy extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      copied: false,
    };
  }

  componentWillUnmount() {
    if (this.interval) {
      clearTimeout(this.interval);
    }
  }

  onClick = () => {
    const { url } = this.props;
    copyToClipboard(url);
    this.setState({ copied: true });
    this.interval = setTimeout(this.reset, 4300);
  };

  reset = () => {
    this.setState({ copied: false });
  };

  render() {
    const { children } = this.props;
    const { copied } = this.state;
    const textClass = cc([css.text, { [css.off]: copied, [css.on]: !copied }]);
    const messageClass = cc([css.text, css.message, { [css.on]: copied, [css.off]: !copied }]);
    return (
      <Button {...this.props} onClick={this.onClick}>
        <>
          <span className={textClass}>{children}</span>
          <div className={messageClass}>
            Copied
            <Check />
          </div>
        </>
      </Button>
    );
  }
}

ClickToCopy.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  url: PropTypes.string.isRequired,
};

export default ClickToCopy;
